<template lang="pug">
.attendance-container
  Popup(
    :visible="shortcutKeysGuide",
    :closeOutside="true",
    :paging.enabled="false",
    :useCustomClose="true",
    title="Shortcut Keys",
    width="40%",
    height="335",
    @hiding="hidePopup"
  )
    .shortcuts
      DxDataGrid.shortcut(:dataSource="shortcutDatasource", :showBorders="true", :showRowLines="true")
      Button.button(text="Close", @click="setRootState({ shortcutKeysGuide: false })", ghost, small)
</template>
<script lang="ts">
import { Vue, Component } from "vue-property-decorator";
import { BasePopup as Popup } from "@cruciallearning/puddle";
import { mapMutations, mapState } from "vuex";
import DxDataGrid from "devextreme-vue/data-grid";
import { BaseButton as Button } from "@cruciallearning/puddle";
import { SetRootState } from "@/types";

@Component({
  components: { Popup, DxDataGrid, Button },
  computed: {
    ...mapState(["shortcutKeysGuide"]),
  },
  methods: {
    ...mapMutations(["setRootState"]),
  },
})
export default class ShortcutKeys extends Vue {
  shortcutDatasource = [
    { action: "Previous Slide", key: ["Left Arrow", " Page Up", " Up Arrow"] },
    { action: "Next Slide", key: ["Right Arrow", " Page Down", " Down Arrow", " Enter"] },
    { action: "Play Media", key: ["––"] },
    { action: "Blackout Slide", key: ["––"] },
  ];
  private setRootState!: SetRootState;
  hidePopup(): void {
    this.setRootState({ shortcutKeysGuide: false });
  }
}
</script>
<style lang="scss" scoped>
.shortcut {
  font-size: 14px;
}
::v-deep .dx-datagrid-headers {
  font-weight: bold;
  color: white;
}
.button {
  margin-top: 25px;
  margin-bottom: 25px;
}
::v-deep .dx-datagrid-rowsview {
  max-height: 50vh;
  overflow-y: auto;
}
.shortcuts {
  overflow-x: scroll;
}
</style>
